import * as React from 'react';

export default class DoomsdayHeader extends React.PureComponent {
  public render() {
    return (
      <div className="row mb-5">
        <div className="col" />
        <div className="col">
          <h1 className="text-center"><a href="https://en.wikipedia.org/wiki/Doomsday_rule" target="_blank">Doomsday Algorithm</a> Practice</h1>
        </div>
        <div className="col" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Doomsday/DoomsdayHeader.tsx